// Login
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

// Auth
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";

// Logout
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

// Alert
export const SHOW_ALERT = "SHOW_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

// Categories
export const MAIN_CATEGORIES_SUCCESS = "MAIN_CATEGORIES_SUCCESS";
export const MAIN_CATEGORIES_FAIL = "MAIN_CATEGORIES_FAIL";
export const CHILD_CATEGORIES_SUCCESS = "CHILD_CATEGORIES_SUCCESS";
export const CHILD_CATEGORIES_FAIL = "CHILD_CATEGORIES_FAIL";
export const SUB_CATEGORIES_SUCCESS = "SUB_CATEGORIES_SUCCESS";
export const SUB_CATEGORIES_FAIL = "SUB_CATEGORIES_FAIL";
export const CHILD_SUBCATEGORIES_SUCCESS = "CHILD_SUBCATEGORIES_SUCCESS";
export const CHILD_SUBCATEGORIES_FAIL = "CHILD_SUBCATEGORIES_FAIL";

// Slider

export const FETCH_SLIDER_SUCCESS = "FETCH_SLIDER_SUCCESS";
export const FETCH_SLIDER_FAIL = "FETCH_SLIDER_FAIL";

// user
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL";

// products
export const PRODUCT_SUCCESS = "PRODUCT_SUCCESS";
export const PRODUCT_FAIL = "PRODUCT_FAIL";
// cart
export const CART_ADD_SUCCESS = "CART_ADD_SUCCESS";
export const CART_REMOVE = "CART_REMOVE";
export const CART_ADD_FAIL = "CART_ADD_FAIL";
export const UPDATE_FROM_SERVER = "UPDATE_FROM_SERVER";

// brand
export const BRAND_SUCCESS = "BRAND_SUCCESS";
export const BRAND_FAIL = "BRAND_FAIL";

export const SHIPMENT_ADD_SUCCESS = "SHIPMENT_ADD_SUCCESS";
export const SHIPMENT_ADD_FAIL = "SHIPMENT_ADD_FAIL";
export const SHIPMENT_REMOVE = "SHIPMENT_REMOVE";
